import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from 'state/auth';

const UnverifiedPrivateRoute = () => {
  const { user, isUserEmailVerified } = useUser();

  if (!user) {
    return (
      <Navigate
        to="/login"
        state={{
          // pass in the current pathname, and current queryparams (ie: search)
          from: { pathname: window.location.pathname, search: window.location.search },
        }}
        replace
      />
    );
  }

  if (isUserEmailVerified) {
    return <Navigate to="/dashboard" />;
  }

  return <Outlet />;
};

export default UnverifiedPrivateRoute;
